import React from "react";
import Icon from "../../Icon/icon";
import { IconSizes } from "../../Icon/icon.types";
import { NewsletterOptinMessageIcons } from '../newsletterOptin.types';
import { IconContainer } from './messageIcon.style';

const MessageIcon = ({ icon }: { icon: NewsletterOptinMessageIcons }) => {
  if (
    icon === NewsletterOptinMessageIcons.CHECK ||
    icon === NewsletterOptinMessageIcons.ERROR
  ) {
    return (
      <IconContainer messageIcon={icon}>
        <Icon
          name={
            icon === NewsletterOptinMessageIcons.CHECK
              ? "checkmark"
              : "prohibited"
          }
          size={IconSizes.MD}
          fill={"#fff"}
        />
      </IconContainer>
    );
  } else {
    return null;
  }
};

export default MessageIcon;
